import axios from './axiosInstance';
import {isString, isArray} from 'lodash';

class QRrequest {
  constructor(axios) {
    this.axios = axios;
    this.handler = null;
  }

  bindVue(vueObj) {
    this.handler = vueObj;
    return this;
  }

  parseRouter(moduleName, action) {
    const obj = this[moduleName] = {};
    Object.keys(action).forEach(actionName => {
      obj[actionName] = this.request.bind(this, moduleName, actionName, action[actionName].url);
      obj[actionName].type = action[actionName].type;
      obj[actionName].state = 'ready';
    });
  }

  request(moduleName, actionName, url, config={}) {
    const action = this[moduleName][actionName];
    const type = action.type || 'get';

    const data = config.data || {};
    const params = config.params || {};
    const options = config.options || {};
    // URL片段，会拼接到URL后面
    const fragment = config.fragment || [];

    function contactFragment(url, fragment) {
      // fragment只接收Array或String
      if (!isArray(fragment) &&  !isString(fragment)) {
        return url;
      }

      // 将fragment都转为string
      if (isArray(fragment)) {
        fragment = fragment.join('/');
      }

      const lastCharOfUrl = url.charAt(url.length -1);
      // 追加fragment时，确保url以/结尾
      if (lastCharOfUrl !== '/') {
        url = url + '/';
      }

      // 如果fragment以/开始，fragment去除开始的/；否则直接追加
      url += (fragment.charAt(0) === '/' ? fragment.substring(1) : fragment);
      return url;
    }

    // 追加URL片段
    if (fragment.length) {
      url = contactFragment(url, fragment);
    }

    const state = {
      get: () => {
        return this.axios.get(url, {
          params
        })
      },
      post: () => {
        return this.axios.post(url, data, {
          params,
          ...options
        })
      },
      put: () => {
        return this.axios.put(url, data, {
          params
        })
      },
      delete: () => {
        return this.axios.delete(url, {
          params
        })
      },
      upload: (isBatch) => {
        const formData = new FormData();
        if (isBatch) {
          // data.forEach((item) => formData.append('file', item, item.name));
          data.files.forEach((item) => formData.append('files', item.file, item.fileName));
          delete data['files'];
          for(let i in data){
            formData.set(i, data[i]);
          }
        } else {
          for(let i in data){
            formData.set(i, data[i]);
          }
          // formData.set('file', data, data.name);
        }
        
        return this.axios.post(url, formData, {
          params,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
      },
      batchUpload: () => {
        return state.upload(true);
      },
    }

    // 避免同一条请求未响应时，重复下发
    // if (action.state === 'ready') {
    //   action.state = 'pending';
    //   return state[type]()
    //     .then(
    //       (data) => data,
    //       (error) => {throw error}
    //     ).finally(() => {
    //       action.state = 'ready';
    //     });
    // }
    return state[type]()
    .then(
      (data) => data,
      (error) => {throw error}
    ).finally(() => {
      action.state = 'ready';
    });
  }
}

export default new QRrequest(axios);
